import React from "react";

import dynamic from "next/dynamic";

const EditArticlePage = dynamic(() => import("@/containers/Article/ArticleEditorTinymce"));

function Article() {
  return <EditArticlePage />;
}

Article.auth = true;
export default Article;
